import { render, staticRenderFns } from "./AttachmentBox.vue?vue&type=template&id=3381546e&scoped=true"
import script from "./AttachmentBox.vue?vue&type=script&lang=js"
export * from "./AttachmentBox.vue?vue&type=script&lang=js"
import style0 from "./AttachmentBox.vue?vue&type=style&index=0&id=3381546e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3381546e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3381546e')) {
      api.createRecord('3381546e', component.options)
    } else {
      api.reload('3381546e', component.options)
    }
    module.hot.accept("./AttachmentBox.vue?vue&type=template&id=3381546e&scoped=true", function () {
      api.rerender('3381546e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rows/message-rows/AttachmentBox.vue"
export default component.exports